import { ProcessConfig, StateNode } from '../types';

export function editEans(options: ProcessConfig): StateNode {
  return {
    exit: 'eanHandled',
    on: {
      SAVE_EANS: {
        target: 'handleEanSave',
      },
      GO_BACK: 'itemCounter',
    },
  };
}
